// Import the package
import { parse } from 'csv-parse';
import { transform } from 'stream-transform';
import { stringify } from 'csv-stringify';

// TODO: not installed, as it is not required right now.
// import { generate } from 'csv-generate';

/**
 * @param {object} [options]
 * @param {number} options.seed
 * @param {number} options.columns
 * @param {number} options.length
 
export const CSVGenerate = (options) => {
  return new Promise((resolve, reject) => {
    const callback = (error, output) =>
      error ? reject(error) : resolve(output);

    options ? generate(options, callback) : generate(callback);
  });
};
*/

/**
 * Parses a CSV file into an array of rows.
 * @param {string} input
 * @param {object} [options]
 */
export const CSVParse = (input, options) => {
  return new Promise((resolve, reject) => {
    const callback = (error, output) => (error ? reject(error) : resolve(output));

    options ? parse(input, options, callback) : parse(input, callback);
  });
};

/**
 *
 * @param {string[][]} data
 * @param {function} handler
 * @param {object} [options]
 */
export const CSVTransform = (data, handler, options) => {
  return new Promise((resolve, reject) => {
    const callback = (error, output) => (error ? reject(error) : resolve(output));

    options ? transform(data, handler, options, callback) : transform(data, handler, callback);
  });
};

/**
 *
 * @param {string[][]} data
 * @param {object} options
 */
export const CSVStringfy = (data, options) => {
  return new Promise((resolve, reject) => {
    const callback = (error, output) => (error ? reject(error) : resolve(output));

    options ? stringify(data, options, callback) : stringify(data, callback);
  });
};

export default {
  CSVStringfy,
  CSVParse,
  CSVTransform,
  // CSVGenerate
};
